export const SET_LANGUAGE = '@language/setLanguage'
